import { START_GET_RESOURCETYPES } from '../types';
    
export const getResourcetypes = () => ({
    type: START_GET_RESOURCETYPES
})